'use strict'

const SnakeToCamelCase = (str: string) => {
    return str.toLowerCase().replace(/_/g, ' ').replace(/(?:^|\s)\S/g, (a: string) => { return a.toUpperCase() }).replace(/ /g, '')
}

export default SnakeToCamelCase
